import React, { useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import { P } from '../Typography/styles';
import { SidebarContainer, SidebarWrapper, SidebarBrand, SidebarDropdown, SidebarDropdownTitle, SidebarDropdownLabel, SidebarDropdownLinks } from './styles';
import logo from '../../assets/images/logo-dashboard.svg';
import colors from '../../assets/styles/colors';

const Sidebar = ({routesByRol}) => {
  const [simulationDropdownDashboard, setSimulationDropDownDashboard] = useState(true);
  const [simulationDropdownRadicadas, setSimulationDropDownRadicadas] = useState(true);
  const [simulationDropdownNovedades, setSimulationDropDownNovedades] = useState(true);
  const [simulationDropdownCdt, setSimulationDropDownCdt] = useState(true);
  const [simulationDropdownEncuestas, setSimulationDropDownEncuestas] = useState(true);
  const [listaMisSolicitudes, setListaMisSolicitudes] = useState(['mis_solicitudes/pendientes_radicar', 'mis_solicitudes/radicadas', 'mis_solicitudes/pendientes_adjuntar' , 'mis_solicitudes/pendientes_identidad']);
  const [listaSimulacion, setListaSimulacion] = useState(['simulacion/simulador', 'simulacion/simulacion/detalle_saldos', 'simulacion/excepciones', 'simulacion/simulador-agil','simulacion/envio-habeas']);
  const [listaNovedades, setListaNovedades] = useState(['novedades/modificar_datos', 'novedades/anular_creditos', 'novedades/pagos']);
  const [listaCdt, setListaCdt] = useState(['cdt/consulta']);
  const [listaEncuesta, setListaEncuestas] = useState(['encuestas/admin']);

  return (
    <SidebarContainer id="sidebar">
      <SidebarWrapper background={colors.bgPrimary}>
        <SidebarBrand>
          <NavLink to="/admin/dashboard">
            <img src={logo} alt="Logo Excel Credit" style={{height: '45px'}}/>
          </NavLink>
        </SidebarBrand>
        {(routesByRol.filter(role => listaMisSolicitudes.includes(role)).length > 0) &&
          <SidebarDropdown>
            <SidebarDropdownTitle onClick={() => setSimulationDropDownRadicadas(!simulationDropdownRadicadas)}
                                  open={simulationDropdownRadicadas}>
              <SidebarDropdownLabel>Mis Solicitudes</SidebarDropdownLabel>
              <BsChevronDown color={colors.textExGrayLight} size={15}/>
            </SidebarDropdownTitle>
            <SidebarDropdownLinks open={simulationDropdownRadicadas}>
              {routesByRol.includes("mis_solicitudes/pendientes_radicar") &&
                <NavLink to="/admin/dashboard" activeClassName="active">
                  <P color={colors.white}>Pendientes por Radicar</P>
                </NavLink>
              }
              {routesByRol.includes("mis_solicitudes/radicadas") &&
                <NavLink to="/admin/radicadas">
                  <P color={colors.white}>Estado de crédito</P>
                </NavLink>
              }
              {routesByRol.includes("mis_solicitudes/pendientes_adjuntar") &&
                <NavLink to="/admin/pendientes_adjuntar">
                  <P color={colors.white}>Pendientes por adjuntar</P>
                </NavLink>
              }
              {routesByRol.includes("mis_solicitudes/pendientes_identidad") &&
                <NavLink to="/admin/pendientes_identidad">
                  <P color={colors.white}>Validación de identidad</P>
                </NavLink>
              }
            </SidebarDropdownLinks>
          </SidebarDropdown>
        }
        {(routesByRol.filter(role => listaSimulacion.includes(role)).length > 0) &&
          <SidebarDropdown>
            <SidebarDropdownTitle onClick={() => setSimulationDropDownDashboard(!simulationDropdownDashboard)}
                                  open={simulationDropdownDashboard}>
              <SidebarDropdownLabel>Simulación</SidebarDropdownLabel>
              <BsChevronDown color={colors.textExGrayLight} size={15}/>
            </SidebarDropdownTitle>
            <SidebarDropdownLinks open={simulationDropdownDashboard}>
            {routesByRol.includes("simulacion/envio-habeas") &&
                <NavLink to="/admin/send-habeas">
                  <P color={colors.white}>Habeas Data</P>
                </NavLink>
              }
              {routesByRol.includes("simulacion/simulador") &&
                <NavLink to="/admin/simulator">
                  <P color={colors.white}>Simulador</P>
                </NavLink>
              }
              {routesByRol.includes("simulacion/simulador-agil") &&
                <NavLink to="/admin/agile-simulator">
                  <P color={colors.white}>Simulador Ágil</P>
                </NavLink>
              }
              {routesByRol.includes("simulacion/detalle_saldos") &&
                <NavLink to="/admin/detalle-saldos">
                  <P color={colors.white}>Detalle Saldos</P>
                </NavLink>
              }
              {routesByRol.includes("simulacion/excepciones") &&
                <NavLink to="/admin/processed-exceptions">
                  <P color={colors.white}>Excepciones</P>
                </NavLink>
              }
            </SidebarDropdownLinks>
          </SidebarDropdown>
        }
        {(routesByRol.filter(role => listaNovedades.includes(role)).length > 0) &&
          <SidebarDropdown>
            <SidebarDropdownTitle onClick={() => setSimulationDropDownNovedades(!simulationDropdownNovedades)}
                                  open={simulationDropdownNovedades}>
              <SidebarDropdownLabel>Novedades</SidebarDropdownLabel>
              <BsChevronDown color={colors.textExGrayLight} size={15}/>
            </SidebarDropdownTitle>
            <SidebarDropdownLinks open={simulationDropdownNovedades}>
              {routesByRol.includes("novedades/modificar_datos") &&
                <NavLink to="/admin/client-list">
                  <P color={colors.white}>Modificar Datos</P>
                </NavLink>
              }
              {routesByRol.includes("novedades/anular_creditos") &&
                <NavLink to="/admin/anular-list">
                  <P color={colors.white}>Anular Créditos</P>
                </NavLink>
              }
              {routesByRol.includes("novedades/pagos") &&
                <NavLink to="/admin/pagos">
                  <P color={colors.white}>Pagos</P>
                </NavLink>
              }
            </SidebarDropdownLinks>
          </SidebarDropdown>
        }
        {(routesByRol.filter(role => listaCdt.includes(role)).length > 0) &&
          <SidebarDropdown>
            <SidebarDropdownTitle onClick={() => setSimulationDropDownCdt(!simulationDropdownCdt)}
                                  open={simulationDropdownCdt}>
              <SidebarDropdownLabel>CDT</SidebarDropdownLabel>
              <BsChevronDown color={colors.textExGrayLight} size={15}/>
            </SidebarDropdownTitle>
            <SidebarDropdownLinks open={simulationDropdownCdt}>
              {routesByRol.includes("cdt/consulta") &&
                <NavLink to="/admin/cdt">
                  <P color={colors.white}>Consulta</P>
                </NavLink>
              }
            </SidebarDropdownLinks>
          </SidebarDropdown>
        }
        {(routesByRol.filter(role => listaEncuesta.includes(role)).length > 0) &&
          <SidebarDropdown>
            <SidebarDropdownTitle onClick={() => setSimulationDropDownEncuestas(!simulationDropdownEncuestas)}
                                  open={simulationDropdownEncuestas}>
              <SidebarDropdownLabel>Encuestas</SidebarDropdownLabel>
              <BsChevronDown color={colors.textExGrayLight} size={15}/>
            </SidebarDropdownTitle>
            <SidebarDropdownLinks open={simulationDropdownEncuestas}>
              {routesByRol.includes("encuestas/admin") &&
                <NavLink to="/admin/survey">
                  <P color={colors.white}>Administrador</P>
                </NavLink>
              }
            </SidebarDropdownLinks>
          </SidebarDropdown>
        }
      </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar;
